// extracted by mini-css-extract-plugin
export default {"footerBox":"Footer_footerBox__WDPmw"};